export const miDtData = {
  fechaSuscripcionContrato: "Fecha suscripcion de contrato",
  rut: "RUT",
  nombres: "Nombres",
  apellidoPaterno: "Apellido paterno",
  apellidoMaterno: "Apellido materno",
  fechaNacimiento: "Fecha de nacimiento",
  sexo: "Sexo",
  nacionalidad: "Nacionalidad",
  estadoCivil: "Estado Civil",
  telefono1: "Telefono",
  cargoNombre: "Cargo",
  ciudad: "Ciudad",
  regionId: "Region",
  comuna: "Comuna",
  direccion: "Direccion",
  serviciosCalle: "Calle Centro de Costo",
  serviciosNro: "Numero Centro de Costo",
  serviciosComuna: "Comuna Centro de Costo",
  serviciosRegion: "Region Centro de Costo",
  serviciosNombre: "Nombre Centro de Costo",
  serviciosNombreCliente: "Nombre Cliente",
  formaPago: "Forma de pago",
  fechaVencimientoContrato: "Fecha vencimiento de contrato",
  diaSiguienteVC: "Día siguiente al vencimiento de contrato",
  fechaProrrogaContrato: "Fecha de Prorroga",
  serviciosUbicadoEn: "Ubicacion Centro de Costo",
  serviciosCiudad: "Ciudad Centro de Costo",
  p001: "P001",
  p025: "P025",
  p060: "P060",
  p070: "P070",
  p027: "P027",
  p039: "P039",
  p300: "P300",
  email: "email",
  emailApiGS: "Email validado para firmar",
  salud: "Salud",
  afp:"Afp",
};
